import Flickity from 'flickity';
require('flickity-imagesloaded');

export default function imageRail() {
  document.querySelectorAll('.rail__slideshow').forEach((element) => {
    window[element.dataset.slideshowId] = new Flickity(element, {
      prevNextButtons: element.dataset.pagination,
      pageDots: false,
      contain: true,
      groupCells: 1,
      cellAlign: 'left',
      lazyLoad: true,
      imagesLoaded: true,
    });
  });
}
